import unhappyImage from 'assets/image/snail-no.png'
import happyImage from 'assets/image/snail-subscription.png'
import { CONSTS } from 'config/objectConst'
import { Link } from 'react-router-dom'
import { appDay } from 'shared/day'
import { useAppSelector } from 'shared/hooks'
import { Button } from 'shared/ui'

import { appSelectors } from '../../../redux/reducers/app'
import css from './TrialNotification.module.scss'

const NOW = appDay(),
	TRIAL_KEY = CONSTS.SUBSCRIPTIONS.TRIAL.ID

export function TrialNotification() {
	// ! was broken before switch to FC, connected to not exist state
	// const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const isImpersonated = false

	const subscription = useAppSelector(appSelectors.subscription)

	const isActive = Boolean(subscription?.is_active),
		isTrial = subscription?.plan_id === TRIAL_KEY,
		isActiveSubscription = !isTrial && isActive && !isImpersonated,
		isActiveTrial = isTrial && isActive && !isImpersonated,
		isExpiredTrial = isTrial && !isActive && !isImpersonated,
		isInactiveSubscription = !isTrial && !isActive && !isImpersonated,
		isSubscriptionExpired = isExpiredTrial || isInactiveSubscription

	if (!subscription?.plan_id) {
		return null
	}

	const generateTitle = () => {
		if (isActiveTrial) {
			return `Trial will expire in ${getUnits(subscription.next_charge_date)}`
		}

		if (isExpiredTrial) {
			return 'Trial period is expired'
		}
		if (isActiveSubscription) {
			return 'Subscription is active'
		}
		if (isInactiveSubscription) {
			return 'Subscription is inactive'
		}
	}

	return (
		<div className={isSubscriptionExpired ? css.accent : css.root}>
			<p className={css.title}>{generateTitle()}</p>
			<Button as={Link} className={css.cta} to={'/upgrade'} variant='secondary'>
				Upgrade subscription
			</Button>

			<img
				alt='snail'
				className={css.pic}
				src={isSubscriptionExpired ? unhappyImage : happyImage}
				width={42}
			/>
		</div>
	)
}

function getUnits(datetime: string) {
	const asDay = appDay(datetime)

	let diff = Math.ceil(asDay.diff(NOW, 'hour', true))

	let units = 'hour'
	if (diff > 24) {
		units = 'day'
		diff = Math.ceil(asDay.diff(NOW, 'day', true))
	}

	if (diff > 1) {
		units += 's'
	}
	return `${diff} ${units}`
}

export default TrialNotification
